import { FC, useState } from 'react';
import { SubTabProps } from './subTabTypes';
import styles from './subTab.module.scss';

const SubTab: FC<SubTabProps> = (props: SubTabProps) => {
    const { text, number, onClick } = props;
    const [selected, setSelected] = useState(false);

    const onClickAction = () => {
        setSelected(!selected);
        onClick();
    };

    return (
        <div className={selected ? styles['subtype-selected'] : styles.subtype}>
            <div className={styles['sub-type-text']} onClick={onClickAction}>
                {text}
            </div>
            {number && <div className={styles['sub-type-text']}>{number}</div>}
        </div>
    );
};

export default SubTab;
